import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFadeOut20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconFadeOut20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M9.147 18.883a.8.8 0 0 1-.184-.026c-4.454-.494-7.918-4.27-7.918-8.855l.012-.458A8.91 8.91 0 0 1 8.94 1.151a.7.7 0 0 1 .207-.033.75.75 0 0 1 .75.75v16.265a.75.75 0 0 1-.75.75m3.025-.438a.75.75 0 0 1-.751-.75V2.31a.75.75 0 0 1 1.5 0v15.386a.75.75 0 0 1-.75.75M8.397 2.76a7.41 7.41 0 0 0 0 14.487zm6.79 14.083a.75.75 0 0 1-.75-.75V3.907a.75.75 0 0 1 1.5 0v12.186a.75.75 0 0 1-.75.75m3.02-2.72a.75.75 0 0 1-.75-.75V6.631a.75.75 0 1 1 1.5 0v6.742a.75.75 0 0 1-.75.75"
            />
        </svg>
    );
}
export default memo(IconFadeOut20);
